import {gsap} from "gsap";
import {FireInTheHole2} from "../FireInTheHole2";
import {BitmapText} from "pixi.js";
import {FITH2FontConfig} from "../configs/FITH2FontConfig";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";

export class FreespinsLeftView extends PIXI.Container {
    private _freespinsLeftText: BitmapText;
    private _freespinsLeft: number;
    private _effect: PIXI.Sprite;

    constructor() {
        super();
        this.name = "FreespinsLeftView";
        this.init();
        this.onResize();
    }

    public onRestore(): void {
        this.update(FireInTheHole2.model.data.freespinsLeft);
    }

    public update(value: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        if (value < this._freespinsLeft) {
            tl.add(gsap.to(this._effect, 0, {alpha: 1}), 0.04);
        }

        if (!(FireInTheHole2.model.freespinTriggeredThisSpin || FireInTheHole2.model.isNextNormal) && this._freespinsLeft != 3 && value === 3) {
            tl.add(() => {
                FITH2SoundManager.playSound("fsSpinsReset");
            }, 0.04);
        }
        this._freespinsLeft = value;
        tl.add(gsap.to(this._freespinsLeftText.scale, 0, {x: 1.1, y: 1.1}), 0);
        tl.add(gsap.to(this._freespinsLeftText.scale, 0.1, {x: 1, y: 1}), 0);
        tl.add([
            gsap.to(this._effect, 0.06, {alpha: 0}),
            () => {
                this._freespinsLeftText.text = `${value}`;
            }], 0.04);
        return tl;
    }

    private init(): void {
        this._freespinsLeftText = new BitmapText("", FITH2FontConfig.FREESPINS_LEFT);
        const container = new PIXI.Sprite(FireInTheHole2.assetLoader.getTextures("board")[0]);
        container.anchor = new PIXI.Point(0.5);
        container.position.set(6, -47);
        this._freespinsLeftText.anchor = new PIXI.Point(0.5, 0.5);
        this._effect = new PIXI.Sprite(FireInTheHole2.assetLoader.getTextures("freespin/board_red")[0]);
        this._effect.anchor.set(0.5, 0.5);
        this._effect.blendMode = PIXI.BLEND_MODES.ADD;
        this._effect.alpha = 0;
        this.addChild(container, this._effect, this._freespinsLeftText);
    }

    public hide(): void {
        this.visible = false;
    }

    public setMode(mode: string): void {
        const isNormal: boolean = mode[0] === "N";
        this.visible = !isNormal;
    }

    public onResize(): void {
        const isLandscape: boolean = NolimitApplication.isLandscape;
        this.position.x = isLandscape ? -76 : 73;
        this.position.y = isLandscape ? 93 : 11;
    }
}